import { Context, Effect, Layer } from 'effect';

import type { ListingScope } from '../../capability/productListing/listingScope';
import type { ListingVocabularyError } from './errors';
import type { ListingVocabulary } from './ListingVocabulary';

export type ListingVocabularyProviderService = {
  readonly forScope: (
    scope: ListingScope
  ) => Effect.Effect<ListingVocabulary, ListingVocabularyError>;
};

export class ListingVocabularyProvider extends Context.Service<
  ListingVocabularyProvider,
  ListingVocabularyProviderService
>()('@engine/Listing/VocabularyProvider') {}

/** Creates a static provider for configuration-owned vocabularies. */
export const vocabularyFromConfig = (
  vocabulary: ListingVocabulary
): Layer.Layer<ListingVocabularyProvider> =>
  Layer.succeed(
    ListingVocabularyProvider,
    ListingVocabularyProvider.of({ forScope: () => Effect.succeed(vocabulary) })
  );
